import { styled } from "@mui/system";
import Typography from "@mui/material/Typography";

const CustomTypography = styled(Typography)({
  fontFamily: "Lato",
});

export default CustomTypography;
